module.exports = __webpack_public_path__ + "static/media/plus-icon.974cd95c.svg";